import { gql } from "@apollo/client";

export const UPDATE_ASSET_MUTATION = gql`
  mutation UpdateAsset($id: ID!, $input: UpdateAssetInput!) {
    updateAsset(id: $id, input: $input) {
      id
      name
      description
      productId
      serialNumber
      installationDate
      locationIds
      userIds
      monitored
      specifications
      assetRelations {
        id
        assetId
        fedFromId
      }
    }
  }
`;

/** Floor-plan relocate / wire / save — skip specifications JSON on the response. */
export const UPDATE_ASSET_FLOOR_PLAN_MUTATION = gql`
  mutation UpdateAssetFloorPlan($id: ID!, $input: UpdateAssetInput!) {
    updateAsset(id: $id, input: $input) {
      id
      locationIds
      assetRelations {
        id
        assetId
        fedFromId
      }
    }
  }
`;

// Create Asset Mutation

export const CREATE_ASSET_MUTATION = gql`
  mutation CreateAsset($input: CreateAssetInput!) {
    createAsset(input: $input) {
      id
      name
      description
      productId
      serialNumber
      installationDate
      locationIds
      userIds
      monitored
      specifications
    }
  }
`;

// Generate Upload URL Mutation

export const DELETE_ASSET_MUTATION = gql`
    mutation DeleteAsset($id: ID!) {
        deleteAsset(id: $id)
    }
`;

// Create Asset Maintenance Schedule Mutation

export const CREATE_ASSET_MAINTENANCE_SCHEDULE_MUTATION = gql`
    mutation CreateAssetMaintenanceSchedule($input: CreateAssetMaintenanceScheduleInput!) {
        createAssetMaintenanceSchedule(input: $input) {
            id
            assetId
            title
            description
            scheduleType
            intervalUnit
            intervalValue
            startDate
            nextDueDate
            timeZone
            assignedToUserIds
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

// Update Asset Maintenance Schedule Mutation

export const UPDATE_ASSET_MAINTENANCE_SCHEDULE_MUTATION = gql`
    mutation UpdateAssetMaintenanceSchedule($input: UpdateAssetMaintenanceScheduleInput!) {
        updateAssetMaintenanceSchedule(input: $input) {
            id
            assetId
            title
            description
            scheduleType
            intervalUnit
            intervalValue
            startDate
            nextDueDate
            timeZone
            assignedToUserIds
            createdAt
            updatedAt
            deletedAt
        }
    }
`;

// Delete Asset Maintenance Schedule Mutation

export const DELETE_ASSET_MAINTENANCE_SCHEDULE_MUTATION = gql`
    mutation DeleteAssetMaintenanceSchedule($id: ID!) {
        deleteAssetMaintenanceSchedule(id: $id)
    }
`;

// Install AI Addon Mutation

export const ADD_ASSET_TIMELINE_EVENT_MUTATION = gql`
  mutation AddAssetTimelineEvent($input: AddAssetTimelineEventInput!) {
    addAssetTimelineEvent(input: $input) {
      id
      assetId
      type
      title
      notes
      createdAt
      updatedAt
      createdByUser {
        id
        firstName
        lastName
      }
    }
  }
`;

export const UPDATE_ASSET_TIMELINE_EVENT_MUTATION = gql`
  mutation UpdateAssetTimelineEvent($input: UpdateAssetTimelineEventInput!) {
    updateAssetTimelineEvent(input: $input) {
      id
      assetId
      type
      title
      notes
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_ASSET_TIMELINE_EVENT_MUTATION = gql`
  mutation DeleteAssetTimelineEvent($id: ID!) {
    deleteAssetTimelineEvent(id: $id)
  }
`;
